<div style="display: block">
    <div [chart]="chart"></div>
</div>
